
   $('ul.tabs_custom').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      // links.not(':first').each(function () {
      //   $($(this).attr('href')).hide();
      // });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        active = $(this);
        content = $($(this).attr('href'));
        var selector=$(this).attr('href');
        active.addClass('active');        
        jQuery('.collection_prod').removeClass("active_li");
        content.addClass("active_li");
        
        return false;
      });
    });

var banner_slider = new Swiper(".banner_slider", {
  loop: true,
  autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
  slidesPerView: 1,
  pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
});


var rev_box_main = new Swiper(".rev_box_main", {
      slidesPerView: "auto",
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
var rev_box_main_sec = new Swiper(".Cookies-storyinner-sec", {
      slidesPerView: "auto",
      spaceBetween: 30,     
    });


var CT_test_slide = new Swiper(".CT-test-slide", {
  slidesPerView: "auto",
  spaceBetween: 20,
  breakpoints: {
        640: {
          freeMode: false,
          spaceBetween: 20,
          slidesPerView: 1,
        }
      },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

// var swiper_pro = new Swiper(".mySwiper_product", {
//   slidesPerView: "auto",
//   spaceBetween: 10,
//   freeMode: true,
//   // navigation: {
//   //   nextEl: ".swiper-button-next",
//   //   prevEl: ".swiper-button-prev",
//   // },
//   breakpoints: {
//         640: {
//           freeMode: false,
//           spaceBetween: 20,
//         }
//       },
  
// });

// var tabs_custom = new Swiper(".tabs_custom", {
//   slidesPerView: "auto",
//   spaceBetween: 10,
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
// });


var featu_tab = new Swiper(".featu_tab", {
  slidesPerView: "auto",
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var story_vide = new Swiper(".story_vide", {
  slidesPerView: "auto",
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
        640: {
          spaceBetween: 20,
        }
      },
});


$('.text-slider_box').marquee({
    direction: 'left',
    duration: 25000,
    gap: 0,
    delayBeforeStart: 0,
    duplicated: true,
    startVisible: true
});
$('.logo-slider').marquee({
    direction: 'left',
    duration: 25000,
    gap: 0,
    delayBeforeStart: 0,
    duplicated: true,
    startVisible: true
});

// gsap.to(".ani_text_main h2",{
//       transform: "translateX(-100%)",
//       scrollTrigger:{
//         trigger:".ani_text_main-sec",
//         scroller:"body",
//         markers:false,
//         start:"top 10%",
//         end:"top -150%",
//         scrub:3,
//         pin:true
//       }
// })

 $(document).ready(function() {
  $(".set > .sss").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(200);
      $(".set > .sss i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".set > .sss i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".set > .sss").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
        .siblings(".content")
        .slideDown(200);
    }
  });
});